import { useEffect, useState } from "react";
import UsersSvg from "../../assets/assets_svg/users.svg";

import { getApi } from "../../Helpers/Axios";
import { useSelector } from "react-redux";

const Dashboard = () => {

   const [totalMemeber, setTotalMemeber] = useState(0);
   const [totalAdminAppr, setTotalAdminAppr] = useState(0);
   const [totalSuAdminAppr, setTotalSuAdminAppr] = useState(0);

   const admin = useSelector((state) => state?.auth?.user);

   useEffect(() => {
      fetchUsers();
   }, []);

   const fetchUsers = async () => {
      let url = `get-dashboard`
      await getApi(url, true).then(async (response) => {
         if (response.status === 200) {
            setTotalMemeber(response.data.both_appr);
            setTotalAdminAppr(response.data.admin_appr);
            setTotalSuAdminAppr(response.data.su_admin_appr);
         }
      })
   }

   return (
      <>
         <div className=" row">
            <div className="col-md-2">
               <div className="dash-box">
                  <div className="dash-box-icons">
                     <img src={UsersSvg} alt="user svg" />
                  </div>
                  <div className="dash-box-info">
                     <p className="box-count">{totalMemeber}</p>
                     <p className="box-title">All Members</p>
                  </div>
               </div>
            </div>
            <div className="col-md-2">
               <div className="dash-box">
                  <div className="dash-box-icons">
                     <img src={UsersSvg} alt="user svg" />
                  </div>
                  <div className="dash-box-info">
                     <p className="box-count">{totalAdminAppr}</p>
                     <p className="box-title">Main Approvel</p>
                  </div>
               </div>
            </div>
            <div className="col-md-2">
               <div className="dash-box">
                  <div className="dash-box-icons">
                     <img src={UsersSvg} alt="user svg" />
                  </div>
                  <div className="dash-box-info">
                     <p className="box-count">{totalSuAdminAppr}</p>
                     <p className="box-title">Admin Approvel</p>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Dashboard;